const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://apipayroll.gvmtechnologies.net';

export default API_BASE_URL;




